module.exports = __webpack_public_path__ + "static/img/icon-04.5d1f03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/reason/icon-04.png
// module id = MvXV
// module chunks = 1